import { render } from "./Contact.vue?vue&type=template&id=6e038354&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=6e038354&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e038354"

export default script